import 'react';
import classnames from 'classnames';
import { VisuallyHidden } from '@thisisbud/bui-react-visually-hidden';
import { jsxs, jsx } from 'react/jsx-runtime';

const accessibleContentClassName = 'bui-accessible-content';

/**
 * Render content on the screen that offers an alternative suitable for assistive technologies such as screen readers.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { AccessibleContent } from '@thisisbud/bui-react-accessible-content'
 *
 * function Example() {
 *   return <AccessibleContent accessibleAlternative='Foo'>Bar</AccessibleContent>
 * }
 * ```
 */
function AccessibleContent(props) {
  const {
    accessibleAlternative,
    children,
    className,
    id
  } = props;
  return /*#__PURE__*/jsxs("span", {
    className: classnames(accessibleContentClassName, className),
    id: id,
    children: [/*#__PURE__*/jsx(VisuallyHidden, {
      children: accessibleAlternative
    }), /*#__PURE__*/jsx("span", {
      "aria-hidden": true,
      children: children
    })]
  });
}
AccessibleContent.displayName = 'AccessibleContent';

export { AccessibleContent, accessibleContentClassName };
